module.exports = __webpack_public_path__ + "static/img/new_connect.780ff1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/new_connect.png
// module id = aEro
// module chunks = 1